import {
    StackerAPI,
    StackerActions,
    FETCH_STARTED,
    FETCH_COMPLETED,
    byID,
    without,
} from "./utils/utils"
import { unique } from "utils/utils"
import { STACK_SELECTED } from "./stackApi"

// CONSTANTS
export const BLOCKS_FETCHED = "BLOCKS_FETCHED"
export const BLOCK_CREATED = "BLOCK_CREATED"
export const BLOCK_UPDATED = "BLOCK_UPDATED"
export const BLOCK_REMOVED = "BLOCK_REMOVED"

// API
class BlockApi extends StackerAPI {
    path = "blocks/"
}
const blockApi = new BlockApi()

class BlockActions extends StackerActions {
    api = blockApi
    reducer = "blocks"
    actionTypes = {
        fetched: BLOCKS_FETCHED,
        removed: BLOCK_REMOVED,
        created: BLOCK_CREATED,
        updated: BLOCK_UPDATED,
    }
}
let BA = new BlockActions()
BA.actions = { ...BA.actions, fetchByObject: BA.fetchByObject }
export const blockActions = BA.actions

// STATE
const initialState = {
    blocks: [],
    entities: {},
    fetching: [],
}

// REDUCERS
export function blockReducer(state = initialState, action) {
    var blocks, block, fetching
    switch (action.type) {
        case BLOCKS_FETCHED:
            return {
                ...state,
                blocks: unique([...state.blocks, ...action.payload.map(block => block._sid)]),
                entities: { ...state.entities, ...byID(action.payload) },
            }
        case BLOCK_CREATED:
            blocks = [...state.blocks, [action.payload._sid]]
            return {
                ...state,
                blocks,
                entities: { ...state.entities, [action.payload._sid]: action.payload },
            }
        case BLOCK_UPDATED:
            block = { ...state.entities[action.id], ...action.payload }
            return {
                ...state,
                entities: { ...state.entities, [block._sid]: block },
            }
        case BLOCK_REMOVED:
            blocks = state.blocks.map(blocks => without(blocks, action.id))
            return {
                ...state,
                blocks,
            }

        case FETCH_STARTED:
            return { ...state, fetching: [...state.fetching, action.key] }
        case FETCH_COMPLETED:
            fetching = state.fetching.filter(item => item !== action.key)
            return { ...state, fetching: fetching }

        case STACK_SELECTED:
            return initialState
        default:
            return state
    }
}

// SELECTORS
export const getBlockEntities = state => state.blocks.entities
export const getBlocks = state => {
    if (typeof state.blocks.blocks.map !== "function") debugger
    return state.blocks.blocks.map(blockId => state.blocks.entities[blockId])
}

// HELPERS



// WEBPACK FOOTER //
// ./src/data/blockApi.js